import { render, staticRenderFns } from "./overview-panel.vue?vue&type=template&id=56f30074&"
var script = {}
import style0 from "../../../assets/styles/panels/_OverviewPanel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports